export type WithdrawalSummaryTranslations = {
  summary: string;
  myBankAccountDetails: string;
  bankAccountHolder: string;
  accountNumber: string;
  bankName: string;
  memo: string;
  memoDetails: string;
  confirm: string;
};

const withdrawalSummaryTranslationKeys: WithdrawalSummaryTranslations = {
  summary: 'summary',
  myBankAccountDetails: 'my_bank_account_details_@tenant',
  bankAccountHolder: 'bank_account_holder',
  accountNumber: 'account_number',
  bankName: 'bank_name',
  memo: 'memo',
  memoDetails: 'memo_details',
  confirm: 'confirm',
};

export const getWithdrawalSummaryTranslations = (
  t: (key: string, options?: Record<string, string>) => string,
): WithdrawalSummaryTranslations =>
  Object.entries(withdrawalSummaryTranslationKeys).reduce(
    (acc, [key, value]) => {
      acc[key as keyof WithdrawalSummaryTranslations] = t(value);

      return acc;
    },
    {} as WithdrawalSummaryTranslations,
  );
